import script from "./MobileMajorPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./MobileMajorPage.vue?vue&type=script&lang=ts&setup=true"

import "./MobileMajorPage.vue?vue&type=style&index=0&id=3dd28eab&scoped=true&lang=css"

import exportComponent from "D:\\code\\frontEndCode\\collegeSubjectPage\\page\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3dd28eab"]])

export default __exports__